<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5.63853,2C5.52204,2.44052,5.46,2.90309,5.46,3.38C5.46,3.58966,5.47199,3.79655,5.49532,4C5.49532,4,3.66,4,3.66,4C3.66,4,1.95,8,1.95,8C1.95,8,4,8,4,8C4.55,8,5,8.45,5,9C5,9,5,10,5,10C5,10,11,10,11,10C11,10,11,9,11,9C11,8.91183,11.0116,8.82623,11.0333,8.74464C11.1537,8.73837,11.2708,8.7263,11.4238,8.70688C11.5774,8.69948,11.675,8.67779,11.8651,8.63029C11.9524,8.61371,12.0296,8.59794,12.1051,8.58C12.1051,8.58,12.1546,8.58,12.1546,8.58C12.1546,8.58,12.2766,8.53933,12.2766,8.53933C12.2766,8.53933,13.5426,9.81106,13.5426,9.81106C13.9679,10.2819,14.6595,10.58,15.39,10.58C15.6002,10.58,15.8044,10.5553,16,10.5087C16,10.5087,16,13,16,13C16,13.55,15.55,14,15,14C15,14,1,14,1,14C0.45,14,0,13.55,0,13C0,13,0,7.46,0,7.46C0,7.46,2.08,2.61,2.08,2.61C2.23,2.25,2.59,2,3,2C3,2,5.63853,2,5.63853,2C5.63853,2,5.63853,2,5.63853,2ZM15.82,7.53C15.92,7.65,15.99,7.8,16,7.97C16,8.31,15.73,8.58,15.39,8.58C15.21,8.58,15.06,8.51,14.96,8.4C14.96,8.4,12.72,6.15,12.72,6.15C12.59,6.23,12.46,6.31,12.32,6.38C12.3,6.39,12.27,6.4,12.25,6.41C12.11,6.47,11.98,6.53,11.83,6.58C11.83,6.58,11.82,6.58,11.82,6.58C11.68,6.63,11.53,6.66,11.38,6.69C11.34,6.7,11.3,6.71,11.27,6.71C11.12,6.73,10.97,6.75,10.81,6.75C8.96,6.75,7.46,5.24,7.46,3.38C7.46,1.52,8.96,0.01,10.81,0C12.66,0,14.16,1.51,14.16,3.37C14.16,3.53,14.14,3.68,14.12,3.84C14.11,3.88,14.11,3.91,14.1,3.95C14.08,4.1,14.05,4.24,14,4.39C14,4.39,14,4.4,14,4.4C13.95,4.55,13.89,4.68,13.83,4.82C13.82,4.84,13.81,4.87,13.8,4.89C13.73,5.03,13.66,5.16,13.57,5.29C13.57,5.29,15.82,7.53,15.82,7.53C15.82,7.53,15.82,7.53,15.82,7.53ZM10.81,5.59C12.03,5.59,13.02,4.6,13.02,3.37C13.02,2.14,12.03,1.15,10.81,1.15C9.59,1.15,8.6,2.14,8.6,3.37C8.6,4.59,9.59,5.59,10.81,5.59C10.81,5.59,10.81,5.59,10.81,5.59Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'InboxSearch',
} as DefineComponent
</script>
